import React from 'react';
import './JsonGrid.css';

export interface JsonGridProps {
  data: Record<string, any>[] | Record<string, any>;
}

const JsonGrid: React.FC<JsonGridProps> = ({ data }) => {
  const dataArray = Array.isArray(data) ? data : [data];
  
  if (dataArray.length === 0) {
    return <div className="json-grid-empty">No data available</div>;
  }

  const headers = [...new Set(dataArray.flatMap(obj => Object.keys(obj)))];

  return (
    <div className="json-grid-container">
      <table className="json-grid">
        <thead>
          <tr>
            {headers.map((header) => (
              <th key={header}>{header}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {dataArray.map((item, rowIndex) => (
            <tr key={rowIndex}>
              {headers.map((header) => (
                <td key={`${rowIndex}-${header}`}>
                  {item[header] !== undefined && item[header] !== null
                    ? typeof item[header] === 'object'
                      ? JSON.stringify(item[header])
                      : String(item[header])
                    : ''}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default JsonGrid;